/** Convert screen coords (top-left origin, pixels) → PDF points for API. */
export const screenToPdf = (screenX, screenY, pageHeightPt, scale, coordinateOrigin = "bottom_left") => {
	const pdfX = screenX / scale;
	if (coordinateOrigin === "top_left") {
		return { x: Math.round(pdfX * 10) / 10, y: Math.round((screenY / scale) * 10) / 10 };
	}
	return {
		x: Math.round(pdfX * 10) / 10,
		y: Math.round((pageHeightPt - screenY / scale) * 10) / 10,
	};
};

/** Convert PDF points → screen coords (top-left origin) for overlay chips. */
export const pdfToScreen = (pdfX, pdfY, pageHeightPt, scale, coordinateOrigin = "bottom_left") => {
	if (coordinateOrigin === "top_left") {
		return { x: pdfX * scale, y: pdfY * scale };
	}
	return {
		x: pdfX * scale,
		y: (pageHeightPt - pdfY) * scale,
	};
};

export const defaultFieldPosition = (key, page = 0) => ({
	key,
	page,
	x: 72,
	y: 700,
	font_size: 11,
});
